import { Issue } from "../app/Issue";
export default Issue;
